import React from "react";
import { useQueryClient } from "@tanstack/react-query";
import {
  EQUIPMENT_DETAILS_QUERY_KEY,
  PORTFOLIO_EQUIPMENT_QUERY_KEY,
  SITE_EQUIPMENT_PAGE_QUERY_KEY,
  SITE_EQUIPMENT_QUERY_KEY,
} from "./queryKeys";

export function useInvalidateEquipmentQueries() {
  const queryClient = useQueryClient();

  return React.useCallback(
    async ({
      equipmentIds,
      accountId,
      siteId,
    }: {
      equipmentIds?: number[] | null;
      accountId?: number | null;
      siteId?: number | null;
    }) => {
      const allQueries = [];
      if (typeof equipmentIds?.length === "number") {
        equipmentIds.forEach((equipmentId) => {
          allQueries.push(
            queryClient.invalidateQueries({
              queryKey: [EQUIPMENT_DETAILS_QUERY_KEY, equipmentId],
            })
          );
        });
      }
      if (typeof siteId === "number") {
        allQueries.push(
          queryClient.invalidateQueries({
            queryKey: [SITE_EQUIPMENT_QUERY_KEY, siteId],
          })
        );
        allQueries.push(
          queryClient.invalidateQueries({
            queryKey: [SITE_EQUIPMENT_PAGE_QUERY_KEY, siteId],
          })
        );
      }
      if (typeof accountId === "number") {
        allQueries.push(
          queryClient.invalidateQueries({
            queryKey: [PORTFOLIO_EQUIPMENT_QUERY_KEY, accountId],
          })
        );
      }

      return Promise.all(allQueries);
    },
    [queryClient]
  );
}
